import React from 'react';

interface Props {
    languageCode: string;
}

export default function AgencyLabel({ languageCode }: Props) {
    if (languageCode === 'en') {
        return <React.Fragment>{__('Agencies')}</React.Fragment>;
    } else {
        return <React.Fragment>Pro</React.Fragment>;
    }
}
